import { FileSharingAccountDTO } from "../DTO/fileSharingAccountDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateFileSharingAccountRequest extends BasicRequest{
    public fileSharingAccount!: FileSharingAccountDTO;

    constructor(){
        super();
    }
}